import { PropsWithChildren, ReactNode } from 'react';

import { Container } from '@breezeventures/ui-kit/container';
import cn from 'classnames';

type Props = {
  bodyClassName?: string;
  header?: ReactNode;
  footer?: ReactNode;
  withoutPadding?: boolean;
} & PropsWithChildren;

export const Screen = ({
  header,
  footer,
  children,
  withoutPadding,
  bodyClassName,
}: Props) => {
  return (
    <div className={cn('flex h-dvh min-h-dvh w-full flex-col')}>
      {header && <header>{header}</header>}
      <Container
        className={cn(
          `flex w-full max-w-full flex-1 flex-col overflow-y-auto pb-8`,
          {
            'px-0!': withoutPadding,
            'py-0!': withoutPadding,
          },
          bodyClassName
        )}
      >
        {children}
      </Container>

      {footer && (
        <footer className="sticky right-0 bottom-0 left-0 z-10 bg-white">
          {footer}
        </footer>
      )}
    </div>
  );
};
